export const setCookie = (name: string, value: string, months: number) => {
	const expirationDate = new Date()
	expirationDate.setMonth(expirationDate.getMonth() + months)

	const cookieValue = `${value}; expires=${expirationDate.toUTCString()}; path=/`
	document.cookie = `${name}=${cookieValue}`
}
